import { Building2 } from "lucide-react";
import { useBrands } from "../lib/brand";

/**
 * Header brand control. Admins get a dropdown to switch the active brand (drives
 * every brand-scoped page); a brand user sees their single brand as a locked
 * label. Hidden while the brand list is loading or empty.
 */
export function BrandSwitcher() {
  const { brands, activeKey, setActiveKey, canSeeAllBrands, loading } =
    useBrands();

  if (loading || brands.length === 0) return null;

  if (!canSeeAllBrands) {
    const name = brands[0]?.displayName ?? activeKey ?? "";
    return (
      <span className="flex items-center gap-1.5 rounded-md bg-white/10 px-2.5 py-1.5 text-sm font-medium text-white">
        <Building2 className="h-4 w-4 text-teal" />
        {name}
      </span>
    );
  }

  return (
    <label className="flex items-center gap-1.5 rounded-md bg-white/10 px-2 py-1 text-sm text-white">
      <Building2 className="h-4 w-4 shrink-0 text-teal" />
      <select
        aria-label="Brand aktif"
        value={activeKey ?? ""}
        onChange={(e) => setActiveKey(e.target.value)}
        className="max-w-[10rem] cursor-pointer truncate bg-transparent font-medium text-white focus:outline-none [&>option]:text-slate-900"
      >
        {brands.map((b) => (
          <option key={b.key} value={b.key}>
            {b.displayName}
          </option>
        ))}
      </select>
    </label>
  );
}
